import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, Star } from "lucide-react";
import { AVATARS } from "../data/curriculum";
import { useProfile } from "../context/ProfileContext";
import { sfx } from "../services/soundfx";

export default function GameHeader({ title, color = "#F59E0B" }) {
  const navigate = useNavigate();
  const { current } = useProfile();
  const avatar = AVATARS[current?.avatar]?.emoji || "🙂";
  return (
    <header
      className="sticky top-0 z-50 flex items-center justify-between px-3 py-2 border-b-4 shadow-md no-select"
      style={{ background: "#FFFBEBF2", borderColor: color }}
    >
      <button
        data-testid="header-home-btn"
        onClick={() => {
          sfx.tap();
          navigate("/map");
        }}
        className="pop-btn flex items-center justify-center rounded-2xl bg-white border-4 shadow-[0_5px_0_#CBD5E1] active:shadow-none"
        style={{ width: 56, height: 56, borderColor: color }}
        aria-label="Back to map"
      >
        <Home strokeWidth={2.5} className="w-7 h-7 text-slate-700" />
      </button>

      <h1 className="font-display text-xl sm:text-2xl font-bold text-slate-800 truncate px-2">{title}</h1>

      <div
        className="flex items-center gap-2 rounded-2xl px-3 py-2 bg-white border-4 shadow-sm"
        style={{ borderColor: color }}
        data-testid="header-star-count"
      >
        <span className="text-2xl">{avatar}</span>
        <span className="flex items-center gap-1 font-display font-bold text-amber-700">
          <Star className="w-5 h-5 fill-amber-400 text-amber-400" />
          {current?.total_stars ?? 0}
        </span>
      </div>
    </header>
  );
}
